import get from 'lodash/get';
import BaseComponent from 'foundation/base-component';
import userService from '../../../general/js/user/user-service';
import createEvent from '../../../general/js/create-event';
import pageSpinner from '../../../general/js/page-spinner';
import { redirectTo } from '../../../general/js/utils';
import { hasValue } from '../../../general/js/general-helpers';

const INPUTS_SELECTOR = 'input, textarea, select';
const INPUTS_SELECTOR_EXCLUDED = 'input[type=button], input[type=submit], input[type=reset], input[type=hidden]';

const BIND_ATTRIBUTE = 'user-bind';
const BIND_MULTIPLE_ATTRIBUTE = 'user-bind-multiple';
const CONDITION_ATTRIBUTE = 'user-if';

export default class AccountProfileComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    static getRequiredRefs() {
        return [];
    }

    init() {
        pageSpinner.show();
        const isLoggedInPromise = userService.isSecuTixLoggedIn();
        userService.getCurrentUser().then((user) => {
            this.setStylesProfileBlock(user);
            this._user = user;
            isLoggedInPromise.then((status) => {
                this._isLoggedInToSecuTix = status;
                this.applyModel();
                this.element.classList.add('is-visible');
                pageSpinner.hide();
            });
        }, () => {
            this.rejectUser();
        });
    }

    setStylesProfileBlock(user) {
        if (!user.isOneClubMember) return;
        this.refs.profileBlock[0].classList.add('is-one-club-member');
        this.refs.username.insertAdjacentHTML('afterend', '<div class="account-page__username-status">one club member</div>');
    }

    rejectUser() {
        redirectTo(hasValue(this.options.signInUrl) ? this.options.signInUrl : '/');
    }

    isLoggedInToSecuTix() {
        return this._isLoggedInToSecuTix;
    }

    getModel() {
        const user = this._user;
        let optedTheOpenOffersByEmail = get(user, 'optIns.optedTheOpenOffersByEmail', true);
        if (optedTheOpenOffersByEmail === null) {
            optedTheOpenOffersByEmail = true;
        }

        return {
            ...user,
            hasTicketingAccount: userService.hasTicketingAccount(user),
            loggedInToSecuTix: this.isLoggedInToSecuTix(),
            initials: user.firstName && user.lastName ? `${user.firstName[0]}${user.lastName[0]}` : '',
            doNotOptedTheOpenOffersByEmail: !optedTheOpenOffersByEmail
        };
    }

    applyModel() {
        this.applyOneClubStyling();
        this.applyConditions();
        this.applyBindings();
    }

    applyConditions() {
        const conditionElements = [...this.element.querySelectorAll(`[${CONDITION_ATTRIBUTE}]`)];
        conditionElements.forEach((el) => {
            let cond = false;
            let inverse = false;

            let prop = el.getAttribute(CONDITION_ATTRIBUTE);
            if (prop) {
                if (prop[0] === '!') {
                    inverse = true;
                    prop = prop.substring(1);
                }
                cond = this.getModelValue(prop, false);
            }

            cond = inverse ? !cond : cond;
            if (!cond) {
                el.style.display = 'none';
            }
        });
    }

    applyBindings() {
        const bindElements = [...this.element.querySelectorAll(`[${BIND_ATTRIBUTE}]`)];
        const inputElements = [];
        const textElements = [];

        bindElements.forEach((element) => {
            if (element.matches(INPUTS_SELECTOR) && !element.matches(INPUTS_SELECTOR_EXCLUDED)) {
                inputElements.push(element);
            } else {
                textElements.push(element);
            }
        });

        this.applyInputsBindings(inputElements);
        this.applyTextBindings(textElements);
    }

    applyInputsBindings(elements) {
        elements.forEach((el) => {
            const prop = el.getAttribute(BIND_ATTRIBUTE);
            this.applyInputValue(el, this.getModelValue(prop));
        });
    }

    applyInputValue(input, value) {
        switch (input.type) {
            case 'checkbox':
                this.applyCheckboxValue(input, value);
                break;
            case 'radio':
                break;
            case 'select-multiple':
                break;
            default:
                input.value = value || '';
        }
        input.dispatchEvent(createEvent('change'));
    }

    applyCheckboxValue(input, value) {
        if (input.hasAttribute(BIND_MULTIPLE_ATTRIBUTE)) {
            const modelValue = value || [];
            const inputValue = input.value;
            input.checked = modelValue.includes(inputValue);
        } else {
            input.checked = value || false;
        }
    }

    getModelValue(prop, defaultValue) {
        return get(this.getModel(), prop, defaultValue);
    }

    applyTextBindings(elements) {
        elements.forEach((el) => {
            const prop = el.getAttribute(BIND_ATTRIBUTE);
            if (prop) {
                el.innerHTML = this.getModelValue(prop, '');
            }
        });
    }

    applyOneClubStyling() {
        const { isOneClubMember } = this.getModel();
        if (isOneClubMember) {
            this.element.classList.add(this.options.oneClubClass);
        }
    }
}
